var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.546 17.5468C35.546 27.238 27.6907 35.0921 17.9995 35.0921C8.30834 35.0921 0.453857 27.238 0.453857 17.5468C0.453857 7.85566 8.30794 0 17.9995 0C27.6911 0 35.546 7.85603 35.546 17.5468Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3828 14.7964C27.3828 16.3409 26.5545 17.5925 25.531 17.5925C24.5083 17.5925 23.6785 16.3409 23.6785 14.7964C23.6785 13.2519 24.5083 11.9991 25.531 11.9991C26.5545 11.9991 27.3828 13.2523 27.3828 14.7964Z",
    fill: "#562912"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7262 14.7963C12.7262 16.3409 11.8971 17.5924 10.8741 17.5924C9.851 17.5924 9.02148 16.3409 9.02148 14.7963C9.02148 13.2518 9.85096 11.9991 10.8741 11.9991C11.8972 11.9991 12.7262 13.2522 12.7262 14.7963Z",
    fill: "#562912"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2885 27.0416H11.0823C10.6921 27.0416 10.3748 26.6576 10.3748 26.1845C10.3748 25.7093 10.6921 25.3257 11.0823 25.3257H24.2885C24.679 25.3257 24.9961 25.7093 24.9961 26.1845C24.9961 26.6576 24.679 27.0416 24.2885 27.0416Z",
    fill: "#562912"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji3);
export default __webpack_public_path__ + "static/media/Emoji3.f42a290bb39682b888be65a8dea87ea5.svg";
export { ForwardRef as ReactComponent };